"use client";
import React, { useEffect, useRef, useState } from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa6";
import ReactPaginate from "react-paginate";

export default function PaginatedList(props) {
  const { items, itemsPerPage = 15, wrapperClassName, ItemComponent } = props;
  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const navRef = useRef(null);

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(items.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(items.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, items]);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % items.length;
    setItemOffset(newOffset);
  };

  useEffect(() => {
    if (navRef.current) {
      const ulElement = navRef.current.querySelector("ul");
      if (ulElement) {
        ulElement.setAttribute("role", "list");
      }
    }
  }, [pageCount]);

  return (
    <div className={wrapperClassName}>
      {currentItems.map((item, index) => (
        <ItemComponent key={item.id ?? `item-${index}`} item={item} />
      ))}

      <nav ref={navRef} aria-label="Pagination">
        <ReactPaginate
          breakLabel="..."
          nextLabel={<FaArrowRight />}
          onPageChange={handlePageClick}
          pageRangeDisplayed={1}
          marginPagesDisplayed={1}
          pageCount={pageCount}
          previousLabel={<FaArrowLeft />}
          renderOnZeroPageCount={null}
          containerClassName="flex justify-center items-center gap-x-6 mt-6"
          activeClassName="text-textOrange bg-bg-color-light font-bold"
          previousClassName="text-textOrange"
          nextClassName="text-textOrange"
          breakClassName="text-textOrange"
          breakLinkClassName="text-textOrange"
          pageClassName="text-textOrange px-2 py-1"
          pageLinkClassName="text-textOrange"
          disabledClassName="hidden"
        />
      </nav>
    </div>
  );
}
